import { TextField, InputAdornment, IconButton } from "@mui/material";
import { Search as SearchIcon, Close as CloseIcon } from "@mui/icons-material";
export default function SearchField(props) {
  return (
    <TextField
      label={props?.label}
      variant="outlined"
      autoComplete="off"
      value={props.value}
      onChange={(e) => {
        let inputValue = e.target.value;
        const cleanedValue = (inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, ""));
        if (cleanedValue !== props.value) {
          props.onChange(cleanedValue);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" && props.onSubmit) {
          props.onSubmit();
        }
      }}
      placeholder={props.placeholder}
      color="primary"
      fullWidth
      size={props?.size}
      onFocus={() => (props?.isFocused ? props?.isFocused() : null)}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
          endAdornment:
            props.value !== "" ? (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => props.onChange("")}>
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            ) : null
        }
      }}
    />
  );
}
